export enum LocationTypeEnum {
  WINERY = "winery",
}
